import React, { FC } from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";

import Grid from "@material-ui/core/Grid";
import { TheCycleverseTheme } from "src/theme";

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  content: {
    display: "inline-block",
    paddingLeft: theme.globalMarginDesktop,
    paddingRight: theme.globalMarginDesktop,
    [theme.breakpoints.down("xs")]: {
      paddingLeft: theme.globalMarginMobile,
      paddingRight: theme.globalMarginMobile,
    },
    maxWidth: (props: any) => (props.variant == "wide" ? 1500 : 720),
    marginBottom: theme.spacing(6),
  },
  container: {
    maxWidth: (props: any) => (props.variant == "wide" ? 1500 : 450),
    textAlign: "left",
    margin: "auto",
  },
}));

export type ContentProps = {
  headline: any;
  short: any;
  variant?: string;
};

const Content: FC<ContentProps> = (props) => {
  const { headline, short, variant } = props;
  const classes = useStyles({ variant });
  return (
    <Grid container className={classes.content}>
      <Grid item xs={12}>
        {headline}
      </Grid>
      <Grid item xs={12}>
        {short}
      </Grid>
      <Grid item xs={12} className={classes.container}>
        {props.children}
      </Grid>
    </Grid>
  );
};

export default Content;
